import api from '../store/apiClient';

export async function fetchPublicChatConfig() {
  const { data } = await api.get('/chat/public-config');
  return data;
}

export async function fetchPublicKbArticles() {
  const { data } = await api.get('/chat/kb-articles');
  return data;
}

export async function createChatSession(payload) {
  const { data } = await api.post('/chat/sessions', payload);
  return data;
}

export async function fetchChatMessages(conversationId, chatToken) {
  const { data } = await api.get(`/chat/conversations/${conversationId}/messages`, {
    headers: { Authorization: `Bearer ${chatToken}` },
  });
  return data;
}

export async function sendChatMessage(conversationId, chatToken, body) {
  const { data } = await api.post(
    `/chat/conversations/${conversationId}/messages`,
    { body },
    { headers: { Authorization: `Bearer ${chatToken}` } }
  );
  return data;
}

